module.exports = __webpack_public_path__ + "static/media/icon-open-book.c8bc687b.svg";